import script from "./UploadErrors.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadErrors.vue?vue&type=script&setup=true&lang=js"

import "./UploadErrors.vue?vue&type=style&index=0&id=02123330&lang=scss"

const __exports__ = script;

export default __exports__